import { useSuspenseQuery } from '@tanstack/react-query'

import { regionaisKeys } from '@/features/regionais/utils/queries'
import { GetUnidadeDeNegocioService } from '@/http/unidade-negocio.service'
import type { TUnidadesDeNegocioDisponiveisResponse } from '@/types/unidade-negocio'

export const useSuspenseRegionais = () => {
  return useSuspenseQuery<TUnidadesDeNegocioDisponiveisResponse>({
    queryKey: regionaisKeys.listas(),
    queryFn: () => new GetUnidadeDeNegocioService().execute().then((response) => response.data),
    staleTime: 60 * 60 * 1000,
  })
}
